import React, { useContext } from "react";

import Navbar from "../../components/Navbar/navbar";
import CybershieldNavbar from '../../components/Cybershield-component/Cybershield-Navbar/cybershield-navbar'
import { RootContext } from "../../contexts/root-context.js";

import SBOMUploader from "./Posture/SBOMUploader.js";
function CyberShield() {
    const { showConfigureSBOMPage } = useContext(RootContext);
    return (
      <>

      
        <Navbar />
     
      {showConfigureSBOMPage ? <SBOMUploader/> :  <CybershieldNavbar/>}
      </>
    );
  }
  
  export default CyberShield;
  

  